<template>
  <div>
    <v-btn
      v-for="entity in entities"
      :key="`entity-${entity.name}`"
      :color="entity.color"
      height="200px"
      width="200px"
      class="entity-button ma-3"
      @click="handleButtonClick(entity.name)"
      dark
    >
      <span class="mr-3">{{entity.nameEs}}</span>
      <v-icon>{{entity.icon}}</v-icon>
    </v-btn>
  </div>
</template>

<script>

export default {
  data: () => ({
    entities: [
      {
        name: 'careers',
        nameEs: 'cursos',
        color: 'amber darken-4',
        icon: 'mdi-notebook-edit'
      },
      {
        name: 'periods',
        nameEs: 'fechas',
        color: 'deep-purple lighten-2',
        icon: 'mdi-notebook-edit'
      },
      {
        name: 'careers-categories',
        nameEs: 'Categorias',
        color: 'light-blue darken-3',
        icon: 'mdi-puzzle-edit'
      },
      {
        name: 'members',
        nameEs: 'Integrantes',
        color: 'teal darken-3',
        icon: 'mdi-account-edit-outline'
      }
    ]
  }),

  methods: {
    handleButtonClick(name) {
      this.$router.push(`/admin/${name}`)
    }
  }
}
</script>

<style>
</style>